import { render } from "./FirstStepsExplanation.vue?vue&type=template&id=afe60eb4&scoped=true&lang=pug"
import script from "./FirstStepsExplanation.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstStepsExplanation.vue?vue&type=script&setup=true&lang=js"

import "./FirstStepsExplanation.vue?vue&type=style&index=0&id=afe60eb4&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe60eb4"]])

export default __exports__